import { BookOpen, Building2, ClipboardList, Database, Download, FolderKanban, LayoutDashboard, PackagePlus, ShieldCheck, Users } from "lucide-react";

import { hasAnyRole, hasRole, ROLE_NAMES } from "../../Helpers/roles";

export const getWsmNavigation = (user) => {
  const canManagePacks = hasAnyRole(user, [ROLE_NAMES.SUPER_ADMIN, ROLE_NAMES.PLANNER]);
  const isSuper = hasRole(user, ROLE_NAMES.SUPER_ADMIN);

  return [
    { href: "/", icon: LayoutDashboard, label: "Dashboard" },
    {
      defaultExpanded: true,
      icon: ClipboardList,
      label: "Packs",
      children: [
        ...(canManagePacks ? [{ href: "/packs/resume", icon: PackagePlus, label: "Create pack" }] : []),
        { href: "/packs/register", icon: ClipboardList, label: "Packs register" },
        ...(canManagePacks ? [{ href: "/packs/exports", icon: Download, label: "Data exports" }] : []),
      ],
    },
    {
      defaultExpanded: true,
      icon: BookOpen,
      label: "Library",
      children: [
        { href: "/library/elrs", icon: Database, label: "ELRs" },
        { href: "/library/swp-projects", icon: FolderKanban, label: "Projects" },
      ],
    },
    ...(isSuper ? [{
      defaultExpanded: true,
      icon: ShieldCheck,
      label: "Administration",
      children: [
        { href: "/people", icon: Users, label: "People" },
        { href: "/organisations", icon: Building2, label: "Organisations" },
      ],
    }] : []),
  ];
};